import { getDomainOrigin } from 'utils/serverConfig';

const API_ENDPOINTS = {
    gst: {
        fetchGSTDetails: (partnerId: string, groupName: string) =>
            `${getDomainOrigin()}/api/mpos/partner/${partnerId}/user/gst-details/fetch?group_name=${groupName}`,
        submitGSTDetails: (partnerId: string, groupName: string) =>
            `${getDomainOrigin()}/api/mpos/partner/${partnerId}/user/gst-details/submit?group_name=${groupName}`,
        validateGSTDetails: (
            partnerId: string,
            groupName: string,
            async: boolean
        ) =>
            `${getDomainOrigin()}/api/mpos/partner/${partnerId}/user/gst-details/validate?group_name=${groupName}&async=${async.valueOf()}`,
        //  getUser: (id) => `${BASE_URL}/users/${id}`,
    },
};

export default API_ENDPOINTS;
